import { styled } from "styled-components";
const DropdownMenuListInner = styled("div")(
  {
    overflow: "auto",
    padding: 4
  },
  ({ maxHeight }) => ({ maxHeight }),
  ({ minWidth }) => ({ minWidth }),
  ({ spacing }) => ({
    default: {
      padding: 4
    },
    none: {
      padding: 0
    }
  })[spacing],
  ({ width }) => ({ width })
);
const DropdownMenuItems = styled("div")({
  outline: 0
});
export {
  DropdownMenuItems,
  DropdownMenuListInner
};
